/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
import { jsx } from 'theme-ui';
import sizes from './sizes';
/**
 * A download icon.
 * @param {object} props
 * @param {string} [props.className]
 * @param {string} [props.size] The icon size.
 */
export default function ChevronRightIcon({ className, size = 'xsmall' }) {
    return (jsx("svg", { xmlns: "http://www.w3.org/2000/svg", 
        // @ts-ignore
        sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
        }, className: className, viewBox: "0 0 15 15" },
        jsx("path", { fill: "currentColor", transform: "rotate(-90 8.5 4.5)", d: "M10.1607253 0.632722616L10.8392747 1.36727738 5.45326266 6.34263853 0.160725299 1.45362518 0.839274701 0.719070409 5.45326266 4.98126965z" })));
}
//# sourceMappingURL=ChevronRightIcon.js.map